const OPEN_PROFILE_FLAG = "open_profile_modal";
const QB_CONNECTED_FLAG = "qb_connected";

/**
 * OAuth return uses ?profile=true only to open the Profile modal.
 * Strip it from the URL immediately so list pages never send it to APIs.
 */
export function consumeProfileReturnFlagFromUrl() {
  try {
    const url = new URL(window.location.href);
    const raw = String(url.searchParams.get("profile") || "")
      .trim()
      .toLowerCase();
    if (!["1", "true", "yes"].includes(raw)) return false;

    sessionStorage.setItem(OPEN_PROFILE_FLAG, "1");
    url.searchParams.delete("profile");
    const next = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState(null, "", next);
    return true;
  } catch {
    return false;
  }
}

/**
 * QuickBooks OAuth success redirect adds ?qb=connected.
 * Persist a one-shot flag and strip the param from the URL.
 */
export function consumeQbConnectedFlagFromUrl() {
  try {
    const url = new URL(window.location.href);
    const raw = String(url.searchParams.get("qb") || "")
      .trim()
      .toLowerCase();
    if (raw !== "connected") return false;

    sessionStorage.setItem(QB_CONNECTED_FLAG, "1");
    url.searchParams.delete("qb");
    const next = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState(null, "", next);
    return true;
  } catch {
    return false;
  }
}

export function shouldOpenProfileModal() {
  try {
    return sessionStorage.getItem(OPEN_PROFILE_FLAG) === "1";
  } catch {
    return false;
  }
}

export function clearOpenProfileModalFlag() {
  try {
    sessionStorage.removeItem(OPEN_PROFILE_FLAG);
  } catch {
    /* ignore */
  }
}

export function shouldShowQbConnectedToast() {
  try {
    return sessionStorage.getItem(QB_CONNECTED_FLAG) === "1";
  } catch {
    return false;
  }
}

export function clearQbConnectedFlag() {
  try {
    sessionStorage.removeItem(QB_CONNECTED_FLAG);
  } catch {
    /* ignore */
  }
}
